import React from "react";
import { CheckIcon } from "lucide-react";
import { Accent, Container, Eyebrow, H2 } from "./ui";
import { audiences, tagline, workflowSteps } from "../data/content";
export function SolutionSection() {
  return <section className="bg-white py-12 md:py-24" data-id="element-196" data-mp="3oabtnbc1tofa">
      <Container data-id="element-197" data-mp="3o6xusd2lfxcl">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16" data-id="element-198" data-mp="3jah3ja03l2va">
          <div data-id="element-199" data-mp="3jck58ram4kfu">
            <Eyebrow data-id="element-200" data-mp="14ck9bxtjo8x">Introducing</Eyebrow>
            <H2 data-id="element-201" data-mp="139sl1so9hry">
              The Activity Director’s <Accent data-id="element-202" data-mp="128703e15cvz">Year-Round Kit</Accent>
            </H2>
            <p className="mt-5 text-base text-muted sm:text-lg" data-id="element-203" data-mp="3t7lq3axuv0cm">
              One kit that connects each activity to its participant materials and coordinator guidance. You know what
              to print, what to say and how to adapt it before the group arrives.
            </p>
            <p className="mt-4 font-display text-2xl font-bold uppercase text-petrol" data-id="element-204" data-mp="ktmzypxke971">{tagline}</p>
          </div>
          <div className="rounded-2xl bg-cream p-6 md:p-8" data-id="element-205" data-mp="fus3il6ocm4g">
            <h3 className="text-sm font-semibold uppercase tracking-[0.16em] text-petrol" data-id="element-206" data-mp="36avuhb5b57a6">Made for</h3>
            <ul className="mt-4 space-y-3" data-id="element-207" data-mp="3b970fashexn4">
              {audiences.map(a => <li key={a.role} className="flex gap-3" data-id="element-208" data-mp="3fbaiii9np0hd">
                  <span className="mt-[3px] inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage" data-id="element-209" data-mp="3f9r12oc9kje0">
                    <CheckIcon className="h-3 w-3 text-petrol" strokeWidth={3} aria-hidden="true" data-id="element-210" data-mp="3k80vgwq5zfyk" />
                  </span>
                  <span className="text-muted" data-id="element-211" data-mp="3u8b5y9kte9a1">
                    <strong className="text-ink" data-id="element-212" data-mp="3u701s8ngizie">{a.role}:</strong> {a.benefit}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-3 md:mt-14 md:grid-cols-3 md:gap-4" data-id="element-213" data-mp="6u7a5vz2fd24">
          {workflowSteps.map((s, i) => <li key={s.title} className="flex items-start gap-4 rounded-2xl bg-sage p-5 md:p-6" data-id="element-214" data-mp="bsh6wb0fulpu" data-mpi={i}>
              <span className="font-display text-[44px] font-extrabold leading-[0.85] text-petrol md:text-[52px]" data-id="element-215" data-mp="grkcbwkbytyc">
                {i + 1}
              </span>
              <div data-id="element-216" data-mp="27yrjwvwyxlqu">
                <h3 className="font-display text-[22px] font-bold uppercase leading-none text-petrol md:text-2xl" data-id="element-217" data-mp="27zb0o9avu43a">
                  {s.title}
                </h3>
                <p className="mt-2 text-[15px] text-ink" data-id="element-218" data-mp="2hvmgvadlfe30">{s.description}</p>
              </div>
            </li>)}
        </ol>
      </Container>
    </section>;
}